<div id="wrap">
  <div class="preadesao">
    <h1>Confirmação de Cadastro</h1>
    <p>Digite o código de verificação no campo abaixo</p>
    <div class="box adesao">
      <form>

        <input
          [(ngModel)]="token"
          name="token"
          placeholder="Código"
          [disabled]="loading"
          maxlength="10"
          />
          <span></span>

          <button type="submit" class="btn_verde" [disabled]="loading || msgErro!=null" (click)="validarToken()">
            VERIFICAR  @if (loading) {
            <i class="fas fa-spinner fa-spin"></i>
          }
        </button>

        <div class="text-danger text-center erro-servidor" [ngStyle]="{'visibility': msgErro==null ? 'hidden' : 'visible' }">
          {{msgErro}}
        </div>

      </form>
    </div>
  </div>
</div>